var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgReturn = function SvgReturn(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.46 36.72H35.4l4.17-6.2a5.47 5.47 0 0 0-4.5-8.52h-.02c-1.8 0-3.5.82-4.63 2.23L17.63 40.3a2.85 2.85 0 0 0 0 3.56l12.8 16.05a5.92 5.92 0 0 0 4.63 2.23h.01a5.44 5.44 0 0 0 4.5-8.52l-4.16-6.2h41.05c13.2 0 23.89 10.72 23.89 23.95a23.92 23.92 0 0 1-23.9 23.96h-11.6a5.33 5.33 0 0 0 0 10.68h11.62A34.6 34.6 0 0 0 111 71.36a34.6 34.6 0 0 0-34.54-34.64"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgReturn);
export default ForwardRef;